import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
    withStyles,
    Button,
    Divider,
    CircularProgress,
    Typography,
    InputLabel,
    Grid,
    Switch,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Dialog,
    Paper,
    DialogTitle,
    DialogContent,
    Box,
} from '@material-ui/core';
import { verify as verificationMethods } from '../../../sc-utilities/CustomerUtilities';
import WifiForm from '../WifiForm';
import { Delete } from '@material-ui/icons';
import { snackActions } from '../../../sc-utilities/SnackBar';
import PresetMobileSettings from './PresetMobileSettings';
import { TimePicker } from '@material-ui/pickers';
import moment from 'moment';
import { CancelToken } from 'axios';
import * as actions from '../../../sc-customer/Customer/store/customerActions';
import { fetchSecurazeSolutions } from '../../../sc-admin/SecurazeSolution/store/securazeSolutionActions';
import { securazeInitialValues } from '../index';
import * as skuActions from '../../../sc-settings/SKUPattern/store/skuPatternActions';
import AndroidSetupForm from './AndroidSetupForm';
import AppLogoLoading from '../../../sc-logo';
import { enabledField } from '../index';

const styles = (theme) => ({
    root: {
        height: 'auto',
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    paper: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
    },
    paperForm: {
        width: 'auto',
        height: 'auto',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        paddingTop: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingBottom: theme.spacing(1),
    },
    submit: {
        width: '100%',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default,
        },
    },
    addButton: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default,
        },
    },
    text: {
        borderRadius: '1px',
        marginRight: 10,
        color: theme.palette.buttonText.default,
    },
    divider: {
        margin: theme.spacing(1),
    },
    wifiDivider: {
        margin: '15px 0px',
    },
    geolocation: {
        padding: '10px 0',
        marginTop: '10px',
    },
    androidIos: {
        marginTop: '20px',
    },
});

const WorkPresets = (props) => {
    const {
        classes,
        activeCustomerId,
        translations,
        updatePresets,
        loadPresets,
        idParams,
        onFetchSecurazeSolutions,
        customer,
        onFetchErasureMethods,
        onLoadCustomer,
        customerUpdatePresets,
        fetchSKUPattern,
        userEmail,
        sendAndroidSetup,
        userLanguage,
    } = props;

    const [loading, setLoading] = useState(true);

    const [customerPresetFilter, setCustomerPresetsFilter] = useState({
        methods: [],
        securazeSolutions: [],
        skuPatterns: [],
    });

    const [openDialog, setOpenDialog] = useState(false);

    const handleSendEmail = (formData) => {
        const params = {
            Email: formData.Email,
            ActiveCustomerID: activeCustomerId,
            userLanguage,
        };

        if (formData.Wifi) {
            params.Wifi = formData.Wifi;
        }

        sendAndroidSetup(params);
        setOpenDialog(false);
    };

    const formSettingsAndroidSetupForm = {
        Validation: {
            Email: Yup.string().email().required('Required'),
            Wifi: Yup.string().required('Required'),
        },
        ButtonSubmit: {
            Title: translations['send_email'] || 'Send email',
            Color: 'primary',
        },
    };

    let presets = {
        PresetsEnabled: securazeInitialValues.Normal?.PresetsEnabled,
        DifferentMobileSolutions: securazeInitialValues.DifferentMobileSolutions,
        Wifis: securazeInitialValues.Wifis,
        CollectMobileOpsgeolocation: securazeInitialValues.CollectMobileOpsgeolocation,
        AutoshutdownMobile: securazeInitialValues.AutoshutdownMobile,
        AutoshutdownMobileTime: securazeInitialValues.AutoshutdownMobileTime,
        ErasureMobile: securazeInitialValues.ErasureMobile,
    };
    if (customer?.Presets) {
        const customerPresets = JSON.parse(customer.Presets);
        if (customerPresets) {
            presets = {
                PresetsEnabled: customerPresets?.Normal?.PresetsEnabled,
                DifferentMobileSolutions: customerPresets.DifferentMobileSolutions,
                Wifis: customerPresets.Wifis,
                CollectMobileOpsgeolocation: customerPresets.CollectMobileOpsgeolocation,
                AutoshutdownMobile: customerPresets.AutoshutdownMobile,
                AutoshutdownMobileTime: customerPresets.AutoshutdownMobileTime,
                ErasureMobile: customerPresets.ErasureMobile,
            };
        }
    }

    const initialValues = {
        PresetsEnabled: presets?.PresetsEnabled ?? false,
        DifferentMobileSolutions: !!presets?.DifferentMobileSolutions,
        Wifis: presets?.Wifis ?? [],
        CollectMobileOpsgeolocation: !!presets?.CollectMobileOpsgeolocation,
        AutoshutdownMobile: !!presets?.AutoshutdownMobile,
        AutoshutdownMobileTime: presets?.AutoshutdownMobileTime ?? null,
        Android: {
            PrintUponConnection:
                presets?.ErasureMobile?.Android?.PrintUponConnection ??
                presets?.ErasureMobile?.PrintUponConnection ??
                false,
            PrintUponSuccessfulErasure:
                presets?.ErasureMobile?.Android?.PrintUponSuccessfulErasure ??
                presets?.ErasureMobile?.PrintUponSuccessfulErasure ??
                false,
            PrintUponFailedOrAbortedErasure:
                presets?.ErasureMobile?.Android?.PrintUponFailedOrAbortedErasure ??
                presets?.ErasureMobile?.PrintUponFailedOrAbortedErasure ??
                false,
            PrintUponDiagnose:
                presets?.ErasureMobile?.Android?.PrintUponDiagnose ??
                presets?.ErasureMobile?.PrintUponDiagnose ??
                false,
            RemoveAppAfterDiagnose:
                presets?.ErasureMobile?.Android?.RemoveAppAfterDiagnose ??
                presets?.ErasureMobile?.RemoveAppAfterDiagnose ??
                false,
            ErasureAfterDiagnose:
                presets?.ErasureMobile?.Android?.ErasureAfterDiagnose ??
                presets?.ErasureMobile?.ErasureAfterDiagnose ??
                false,
            TypeMobile: presets?.ErasureMobile?.Android?.Type ?? presets?.ErasureMobile?.Type ?? null,
            MethodMobile: presets?.ErasureMobile?.Android?.Method ?? presets?.ErasureMobile?.Method ?? null,
            VerificationMobile:
                presets?.ErasureMobile?.Android?.Verification?.Method ??
                presets?.ErasureMobile?.Verification?.Method ??
                null,
            CustomValueMobile:
                presets?.ErasureMobile?.Android?.Verification?.CustomValue ??
                presets?.ErasureMobile?.Verification?.CustomValue ??
                null,
            UserKPIEnabled:
                presets?.ErasureMobile?.Android?.UserKPI?.Enabled ?? presets?.ErasureMobile?.UserKPI?.Enabled ?? false,
            UserKPICountDiagnosedDevices:
                presets?.ErasureMobile?.Android?.UserKPI?.CountDiagnosedDevices ??
                presets?.ErasureMobile?.UserKPI?.CountDiagnosedDevices ??
                true,
            UserKPICountRegisteredDevices:
                presets?.ErasureMobile?.Android?.UserKPI?.CountRegisteredDevices ??
                presets?.ErasureMobile?.UserKPI?.CountRegisteredDevices ??
                true,
            SKUPatternID: presets?.ErasureMobile?.Android?.SKUPatternID ?? presets?.ErasureMobile?.SKUPatternID ?? '',
        },
        iOS: {
            PrintUponConnection:
                presets?.ErasureMobile?.iOS?.PrintUponConnection ??
                presets?.ErasureMobile?.PrintUponConnection ??
                false,
            PrintUponSuccessfulErasure:
                presets?.ErasureMobile?.iOS?.PrintUponSuccessfulErasure ??
                presets?.ErasureMobile?.PrintUponSuccessfulErasure ??
                false,
            PrintUponFailedOrAbortedErasure:
                presets?.ErasureMobile?.iOS?.PrintUponFailedOrAbortedErasure ??
                presets?.ErasureMobile?.PrintUponFailedOrAbortedErasure ??
                false,
            PrintUponDiagnose:
                presets?.ErasureMobile?.iOS?.PrintUponDiagnose ?? presets?.ErasureMobile?.PrintUponDiagnose ?? false,
            RemoveAppAfterDiagnose:
                presets?.ErasureMobile?.iOS?.RemoveAppAfterDiagnose ??
                presets?.ErasureMobile?.RemoveAppAfterDiagnose ??
                false,
            ErasureAfterDiagnose:
                presets?.ErasureMobile?.iOS?.ErasureAfterDiagnose ??
                presets?.ErasureMobile?.ErasureAfterDiagnose ??
                false,
            TypeMobile: presets?.ErasureMobile?.iOS?.Type ?? presets?.ErasureMobile?.Type ?? null,
            MethodMobile: presets?.ErasureMobile?.iOS?.Method ?? presets?.ErasureMobile?.Method ?? null,
            VerificationMobile:
                presets?.ErasureMobile?.iOS?.Verification?.Method ??
                presets?.ErasureMobile?.Verification?.Method ??
                null,
            CustomValueMobile:
                presets?.ErasureMobile?.iOS?.Verification?.CustomValue ??
                presets?.ErasureMobile?.Verification?.CustomValue ??
                null,
            UserKPIEnabled:
                presets?.ErasureMobile?.iOS?.UserKPI?.Enabled ?? presets?.ErasureMobile?.UserKPI?.Enabled ?? false,
            UserKPICountDiagnosedDevices:
                presets?.ErasureMobile?.iOS?.UserKPI?.CountDiagnosedDevices ??
                presets?.ErasureMobile?.UserKPI?.CountDiagnosedDevices ??
                true,
            UserKPICountRegisteredDevices:
                presets?.ErasureMobile?.iOS?.UserKPI?.CountRegisteredDevices ??
                presets?.ErasureMobile?.UserKPI?.CountRegisteredDevices ??
                true,
            SKUPatternID: presets?.ErasureMobile?.iOS?.SKUPatternID ?? presets?.ErasureMobile?.iOS?.SKUPatternID ?? '',
        },
    };

    const customerCancel = CancelToken?.source();

    const collectPresets = (data) => {
        if (!data.DifferentMobileSolutions) {
            data['iOS'] = data['Android'];
        }

        const presetData = {
            ErasureMobile: {
                Android: {
                    PrintUponConnection: !!data.Android?.PrintUponConnection,
                    PrintUponSuccessfulErasure: !!data.Android?.PrintUponSuccessfulErasure,
                    PrintUponFailedOrAbortedErasure: !!data.Android?.PrintUponFailedOrAbortedErasure,
                    PrintUponDiagnose: !!data.Android?.PrintUponDiagnose,
                    RemoveAppAfterDiagnose: !!data.Android?.RemoveAppAfterDiagnose,
                    ErasureAfterDiagnose: !!data.Android?.ErasureAfterDiagnose,
                    Type: data.Android?.TypeMobile,
                    Method: data.Android?.MethodMobile,
                    Verification: {
                        Method: data.Android?.VerificationMobile,
                        CustomValue: data.Android?.CustomValueMobile,
                    },
                    UserKPI: {
                        Enabled: data?.Android?.UserKPIEnabled,
                        CountDiagnosedDevices: data?.Android?.UserKPICountDiagnosedDevices,
                        CountRegisteredDevices: data?.Android?.UserKPICountRegisteredDevices,
                    },
                    SKUPatternID: data?.Android?.SKUPatternID,
                },
                iOS: {
                    PrintUponConnection: !!data.iOS?.PrintUponConnection,
                    PrintUponSuccessfulErasure: !!data.iOS?.PrintUponSuccessfulErasure,
                    PrintUponFailedOrAbortedErasure: !!data.iOS?.PrintUponFailedOrAbortedErasure,
                    PrintUponDiagnose: !!data.iOS?.PrintUponDiagnose,
                    RemoveAppAfterDiagnose: !!data.iOS?.RemoveAppAfterDiagnose,
                    ErasureAfterDiagnose: !!data.iOS?.ErasureAfterDiagnose,
                    Type: data.iOS?.TypeMobile,
                    Method: data.iOS?.MethodMobile,
                    Verification: {
                        Method: data.iOS?.VerificationMobile,
                        CustomValue: data.iOS?.CustomValueMobile,
                    },
                    UserKPI: {
                        Enabled: data?.iOS?.UserKPIEnabled,
                        CountDiagnosedDevices: data?.iOS?.UserKPICountDiagnosedDevices,
                        CountRegisteredDevices: data?.iOS?.UserKPICountRegisteredDevices,
                    },
                    SKUPatternID: data?.iOS?.SKUPatternID,
                },
            },
            DifferentMobileSolutions: !!data.DifferentMobileSolutions,
            Wifis: data.Wifis,
            CollectMobileOpsgeolocation: !!data?.CollectMobileOpsgeolocation,
            AutoshutdownMobile: !!data?.AutoshutdownMobile,
            AutoshutdownMobileTime: data?.AutoshutdownMobileTime,
        };
        return presetData;
    };

    const handleLoadPresets = () => {
        loadPresets
            ? loadPresets()
            : onLoadCustomer(
                  { CustomerID: activeCustomerId, ActiveCustomerID: activeCustomerId },
                  { cancelToken: customerCancel }
              );
    };

    const handleUpdatePresets = async (presets) => {
        return (await updatePresets)
            ? updatePresets({ Presets: presets, ...idParams, ActiveCustomerID: activeCustomerId })
            : customerUpdatePresets({
                  Presets: presets,
                  CustomerID: customer?.CustomerID,
                  ActiveCustomerID: activeCustomerId,
              });
    };

    useEffect(() => {
        const fetchData = async () => {
            let methods = await onFetchErasureMethods({ ActiveCustomerID: activeCustomerId });
            let securazeSolutions = await onFetchSecurazeSolutions({ ActiveCustomerID: activeCustomerId });
            let skuPatterns = await fetchSKUPattern({
                ActiveCustomerID: activeCustomerId,
                q: { ProductType: 'MobileProduct' },
            });

            if (securazeSolutions && methods) {
                const selectSecurazeSolutions = securazeSolutions?.map((solution) => {
                    return {
                        value: solution.Key,
                        displayValue: solution.LongName,
                    };
                });
                setCustomerPresetsFilter({
                    securazeSolutions: [
                        { value: null, displayValue: translations['none'] || 'None' },
                        ...selectSecurazeSolutions,
                    ],
                    methods: [{ value: null, displayValue: translations['none'] || 'None' }, ...methods],
                    skuPatterns,
                });
            }
            setLoading(false);
        };

        handleLoadPresets();

        fetchData();

        return () => {
            customerCancel.cancel('Operation canceled by user');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomerId]);

    const wifiObject = Yup.object().shape({
        Security: Yup.string().required(),
        SSID: Yup.string().required(),
        Password: Yup.string().required(),
        Username: Yup.string().when('Security', {
            is: (value) => ['wpa_enterprise', 'wpa2_enterprise', 'wpa3_enterprise'].includes(value),
            then: Yup.string().required(),
        }),
    });

    let formSettings = {
        Validation: {
            Wifis: Yup.array().of(wifiObject),
        },
        ButtonSubmit: {
            Title: translations['save'] || 'SAVE',
            Color: 'primary',
        },
    };

    const handleSubmit = async (data) => {
        const presets = collectPresets(data);

        const serverResult = await handleUpdatePresets(presets);
        handleLoadPresets();

        setLoading(false);
        if (serverResult.status) {
            return snackActions.snackBarComponent(translations['update_presets'] || 'Presets updated.', 'success');
        } else {
            return snackActions.snackBarComponent(
                translations['failed_to_update_presets'] || 'Error: Failed to update presets',
                'error'
            );
        }
    };

    return (
        <div className={classes.root}>
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                open={loading}
                PaperProps={{
                    classes: {
                        root: classes.paper,
                    },
                }}
            >
                <AppLogoLoading />
            </Dialog>
            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby="qr-dialog-title"
                disableBackdropClick={false}
                disableEscapeKeyDown={false}
                fullWidth={true}
            >
                <DialogTitle id="qr-dialog-title">
                    {translations['send_qr_code'] || 'Send QR code for automatic android setup'}
                </DialogTitle>
                <DialogContent>
                    <AndroidSetupForm
                        translations={translations}
                        handleSubmit={handleSendEmail}
                        initialValues={{ Email: userEmail }}
                        formSettings={formSettingsAndroidSetupForm}
                        wifis={presets.Wifis}
                    />
                </DialogContent>
            </Dialog>
            <Paper className={classes.paperForm}>
                <Box m={1} display="flex" justifyContent="flex-end">
                    <Button
                        style={{ marginLeft: '30' }}
                        className={classes.btn}
                        variant="contained"
                        color={formSettingsAndroidSetupForm.ButtonSubmit.Color}
                        type="button"
                        onClick={() => setOpenDialog(true)}
                    >
                        {translations['qr_code_for_android'] || 'QR code for android setup'}
                    </Button>
                </Box>
                <Formik
                    initialValues={initialValues}
                    onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);
                        await handleSubmit(values);
                        setSubmitting(false);
                    }}
                    enableReinitialize
                    validationSchema={Yup.object().shape(formSettings.Validation)}
                >
                    {(formikProps) => {
                        const { values, isSubmitting, setFieldValue, handleChange, isValid, setValues, handleSubmit } =
                            formikProps;

                        const addWifi = () => {
                            setValues({
                                ...values,
                                Wifis: [...values.Wifis, { Security: '', SSID: '', Username: '', Password: '' }],
                            });
                        };

                        const removeWifi = (index) => {
                            setValues({ ...values, Wifis: values.Wifis.filter((value, i) => i !== index) });
                        };

                        const handleChangeDifferentMobileSolutions = (e) => {
                            setValues({
                                ...values,
                                ErasureMobile: { ...values, iOS: values['Android'] },
                                DifferentMobileSolutions: e.target.checked,
                            });
                        };

                        const mobileProps = {
                            translations,
                            values,
                            methods: customerPresetFilter.methods,
                            securazeSolutions: customerPresetFilter.securazeSolutions,
                            skuPatterns: customerPresetFilter.skuPatterns,
                            verify: verificationMethods,
                            setFieldValue,
                            handleChange,
                        };

                        return (
                            <form
                                className={classes.form}
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSubmit(e);
                                }}
                            >
                                <Typography align="center" variant={'h5'}>
                                    {translations['mobile_presets'] || 'Mobile Presets'}
                                </Typography>

                                <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    className={classes.geolocation}
                                >
                                    <Grid item xs={12} sm={11}>
                                        <InputLabel>
                                            {translations['different_solution_for_android_and_ios'] ||
                                                'Different erasure solution for Android and iOS'}
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} sm={1}>
                                        <Switch
                                            name={'DifferentMobileSolutions'}
                                            value={values.DifferentMobileSolutions || false}
                                            checked={values.DifferentMobileSolutions || false}
                                            onChange={handleChangeDifferentMobileSolutions}
                                            disabled={enabledField(values)}
                                        />
                                    </Grid>
                                </Grid>
                                {!values.DifferentMobileSolutions ? (
                                    <PresetMobileSettings {...mobileProps} />
                                ) : (
                                    <Grid container direction="row" justify="center" alignItems="center" spacing={5}>
                                        <Grid item xs={12} sm={6}>
                                            <InputLabel className={classes.androidIos}>Android</InputLabel>
                                            <PresetMobileSettings {...mobileProps} osType={'Android'} />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <InputLabel className={classes.androidIos}>iOS</InputLabel>
                                            <PresetMobileSettings {...mobileProps} osType={'iOS'} />
                                        </Grid>
                                    </Grid>
                                )}

                                <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    className={classes.geolocation}
                                >
                                    <Grid item xs={12} sm={11}>
                                        <InputLabel>
                                            {translations['collect_mobile_ops_geolocation'] ||
                                                'Collect MobileOps geolocation'}
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} sm={1}>
                                        <Switch
                                            name={'CollectMobileOpsgeolocation'}
                                            value={values.CollectMobileOpsgeolocation || false}
                                            checked={values.CollectMobileOpsgeolocation || false}
                                            onChange={handleChange}
                                            disabled={enabledField(values)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        color={'primary'}
                                                        margin={'dense'}
                                                        name={'AutoshutdownMobile'}
                                                        checked={values.AutoshutdownMobile || false}
                                                        disabled={enabledField(values)}
                                                        onChange={(event) => {
                                                            setFieldValue('AutoshutdownMobileTime', '22:00');
                                                            handleChange(event);
                                                        }}
                                                    />
                                                }
                                                label={`${
                                                    translations['autoshutdown_mobile'] ||
                                                    'Auto shut down at specific time (Mobile)'
                                                }`}
                                            />
                                            {values['AutoshutdownMobile'] && (
                                                <TimePicker
                                                    clearable
                                                    name={'AutoshutdownMobileTime'}
                                                    onChange={(time) =>
                                                        setFieldValue('AutoshutdownMobileTime', time.format('HH:mm'))
                                                    }
                                                    value={moment(values['AutoshutdownMobileTime'] || '22:00', 'HH:mm')}
                                                />
                                            )}
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                                <Divider className={classes.divider} variant="middle" />
                                <br />

                                <br />
                                <Typography align="center" variant={'h5'}>
                                    {translations['wifis'] || 'Wifis'}
                                </Typography>
                                {values?.Wifis?.map((wifi, index) => (
                                    <React.Fragment key={index}>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="center"
                                            alignItems="center"
                                            spacing={5}
                                        >
                                            <Grid item xs={12} sm={10}>
                                                <WifiForm
                                                    translations={translations}
                                                    index={index}
                                                    formikProps={formikProps}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    onClick={() => removeWifi(index)}
                                                >
                                                    <Delete />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Divider className={classes.wifiDivider} variant="middle" />
                                    </React.Fragment>
                                ))}
                                <Button
                                    className={classes.addButton}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="button"
                                    disabled={!isValid}
                                    onClick={addWifi}
                                >
                                    {translations['add_wifi'] || 'Add wifi'}
                                </Button>

                                {/* Customization*/}
                                {/*<Divider className={classes.divider} variant="middle" />*/}
                                {/*<br />*/}

                                {/*<Grid container direction="row" justify="center" alignItems="center" className={classes.geolocation}>*/}
                                {/*    <Grid item xs={12} sm={11}>*/}
                                {/*        <InputLabel>{translations["enable_customization"] || "Enable customization"}</InputLabel>*/}
                                {/*    </Grid>*/}
                                {/*    <Grid item xs={12} sm={1}>*/}
                                {/*        <Switch name={"EnableCustomization"} value={values.EnableCustomization || false} checked={values.EnableCustomization || false} onChange={handleChange} disabled={enabledField(values)} />*/}
                                {/*    </Grid>*/}
                                {/*</Grid>*/}

                                {/*{values.EnableCustomization && <CustomizationPresets values={values} setFieldValue={setFieldValue} translations={translations} handleChange={handleChange} errors={errors} touched={touched} />} */}

                                <div>
                                    {formSettings.ButtonSubmit ? (
                                        <Button
                                            className={classes.submit}
                                            variant="contained"
                                            color={formSettings.ButtonSubmit.Color}
                                            type="submit"
                                            disabled={!isValid || isSubmitting || loading}
                                        >
                                            {isSubmitting ? (
                                                <CircularProgress size={24} />
                                            ) : (
                                                formSettings.ButtonSubmit.Title
                                            )}
                                        </Button>
                                    ) : null}
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </Paper>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerId: state?.core?.login?.activeCustomer?.CustomerID || null,
        customer: state?.customer?.customers?.loaded || null,
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {},
        userEmail: state?.core?.login?.user?.Email || '',
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage || 'en',
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadCustomer: (customerID, options) => dispatch(actions.loadCustomer(customerID, options)),
        customerUpdatePresets: (params, options) => dispatch(actions.updatePresets(params, options)),
        onFetchErasureMethods: (params) => dispatch(actions.fetchErasureMethod(params)),
        onFetchSecurazeSolutions: (data) => dispatch(fetchSecurazeSolutions(data)),
        fetchSKUPattern: (data) => dispatch(skuActions.fetchSKUPattern(data)),
        sendAndroidSetup: (data) => dispatch(actions.sendAndroidSetup(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(WorkPresets));
